export default "__VITE_ASSET__38e36a09__"